import axios from '../Api/api';

export default function event() {
    return new Promise((resolve, reject) => {
        axios.get("home/eventList", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
